module.exports = __webpack_public_path__ + "static/media/facebook.c9f6021b.svg";